module.exports = __webpack_public_path__ + "static/img/broadcast-icon.822a408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/broadcast-icon.png
// module id = 760
// module chunks = 180